import mixpanel from 'mixpanel-browser'
import cloudinary from 'cloudinary-core'
import {
  CLOUDINARY_NAME,
  CLOUDINARY_API_KEY,
} from '../../../constants/images/cloudinary'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  //upload_preset : CLOUDINARY_VEHICLE_PRESET,
  api_key: CLOUDINARY_API_KEY,
})

export const trackSearchFromHome = (params) => {
  mixpanel.track('New Search - Home', params)
}

export const trackSearchFromHeader = (params) => {
  mixpanel.track('New Search - Header', params)
}

export const trackSearchAPIRan = (desc, params, location, searchMeta) => {
  let searchObject = {
    search_distance_miles: params.distance,
    end_date: params.endDate,
    start_date: params.startDate,
    min_year_filter: params.year ? params.year[0] : '',
    max_year_filter: params.year ? params.year[1] : '',
    min_price_filter: params.priceRange ? params.priceRange[0] : '',
    max_price_filter: params.priceRange ? params.priceRange[1] : '',
    search_page: params.page,
    makes_filter: params.makes ? params.makes : [],
    category_filter: params.category ? params.category : [],
    search_longitude: params.longitude,
    search_latitude: params.latitude,
  }

  if (location instanceof Array) {
    //this makes the location into the right format for mixpanel
    searchObject['search_location'] = location.join(', ')
  } else {
    searchObject['search_location'] = location
  }

  if (desc === 'Search') {
    searchObject['search_goose_egg'] =
      searchMeta.total_results > 0 ? false : true
  } else {
    searchObject['search_goose_egg_type'] =
      searchMeta.total_results > 0 ? 'motorcycles near by' : 'try new search'
  }
  searchObject['total_search_results'] = searchMeta.total_results
  searchObject['total_search_pages'] = searchMeta.total_pages

  mixpanel.track(desc, searchObject)
  //eventually we'll move all gooseegg params into this one.
}
export const trackMobileFiltersOpen = () => {
  mixpanel.track('Mobile Filters Opened')
}

export const trackMobileFiltersClosed = () => {
  mixpanel.track('Mobile Filters Opened')
}

export const trackMobileFiltersCleared = () => {
  mixpanel.track('Mobile Filters Cleared')
}

export const trackMobileFiltersApplied = (params) => {
  let searchObject = {
    search_distance_miles: params.distance,
    end_date: params.endDate,
    start_date: params.startDate,
    min_year_filter: params.year ? params.year[0] : '',
    max_year_filter: params.year ? params.year[1] : '',
    min_price_filter: params.priceRange ? params.priceRange[0] : '',
    max_price_filter: params.priceRange ? params.priceRange[1] : '',
    makes_filter: params.makes ? params.makes : [],
    category_filter: params.category ? params.category : [],
    search_longitude: params.longitude,
    search_latitude: params.latitude,
  }

  if (params.location instanceof Array) {
    //this makes the location into the right format for mixpanel
    searchObject['search_location'] = params.location.join(', ')
  } else {
    searchObject['search_location'] = params.location
  }

  mixpanel.track('Mobile Filters Applied', searchObject)
}

export const trackDesktopMapOn = () => {
  mixpanel.track('Desktop Map On')
}

export const trackDesktopMapOff = () => {
  mixpanel.track('Desktop Map Off')
}

export const trackSearchMapDrag = () => {
  mixpanel.track('Map Dragged')
}

export const trackMapMarkerOpen = (params) => {
  //Come back and fix this up more.

  //READ ME:
  //NEED TO DECIPHER BETWEEN MULTIPLE/SINGLE LISTINGS
  //NEED BIKE PHOTO
  //NEED OWNER PHOTO //all that data.
  //If multiple, then make a list of the bikes.
  //If multiple makes a list of the photos
  //IDs, etc.
  //build links in the code here.

  let motoMapObject = {
    motorcycle_average_rating: params.average_rating,
    motorcycle_category: params.bike_category,
    motorcycle_create_at: params.bike_created,
    distance_from_user: params.bike_distance,
    motorcycle_pretty_id: params.bike_id,
    motorcycle_model: params.bike_model,
    motorcycle_make: params.bike_make,
    motorcycle_year: params.bike_year,
    motorcycle_city: params.bike_location.city,
    motorcycle_country: params.bike_location.country,
    motorcycle_country_abbr: params.bike_location.country_abbreviation,
    motorcycle_region: params.bike_location.region,
    motorcycle_region_abbr: params.bike_location.region_abbrbreviation,
    owner_first_name: params.owner_first_name,
    owner_pretty_id: params.owner_id,
    daily_price: params.day_price_cents / 100,
    daily_price_currency: params.day_price_currency,
    is_newly_listed: params.is_newly_listed,
    motorcycle_reviews_count: params.ratings_count,
  }

  motoMapObject['owner_avatar_large'] = cl.url(params.bike_owner_avatar_id, {
    gravity: 'center',
    height: 300,
    width: 300,
    crop: 'fill',
    format: 'jpg',
  })

  motoMapObject['owner_avatar_small'] = cl.url(params.bike_owner_avatar_id, {
    gravity: 'center',
    height: 125,
    width: 125,
    crop: 'fill',
    format: 'jpg',
  })

  motoMapObject['motorcycle_image_large'] = cl.url(
    params.bike_image_cloudinary_public_id,
    {
      gravity: 'center',
      height: 600,
      width: 900,
      crop: 'fill',
      format: 'jpg',
    }
  )

  motoMapObject['motorcycle_image_small'] = cl.url(
    params.bike_image_cloudinary_public_id,
    {
      gravity: 'center',
      height: 250,
      width: 425,
      crop: 'fill',
      format: 'jpg',
    }
  )

  mixpanel.track('Map Marker Opened', motoMapObject)
}
